import { Role, RoleFromAPI } from './role.entities';

export interface InviteUserReq {
  email: string;
  orgId: number;
  masterWalletsIds?: number[];
  cryptoWalletsIds?: number[];
  cardWalletsIds?: number[];
  role: RoleFromAPI;
}

export interface InvitedUser {
  accountId: number;
  cardWalletsIds: number[];
  created: number;
  cryptoWalletsIds: number[];
  email: string;
  id: number;
  inviteFromEmail: string;
  inviteUrl: string;
  masterWalletsIds: number[];
  orgId: number;
  role: Role;
  status: InviteStatus;
  updated: number;
}

export enum InviteStatus {
  USED = 1,
  PENDING = 2,
  EXPIRED = 3,
  CANCELED = 4,
}
